import Cookies from 'universal-cookie';

import { decrypt, encrypt } from './encrypt';

const cookies = new Cookies(null, { path: '/' });

// Client module user token management

export const setClientToken = (data: IClientTokenData) =>
  cookies.set('client-hash', encrypt(JSON.stringify(data)));

export const getClientToken = (): IClientTokenData => {
  try {
    return cookies.get('client-hash')
      ? JSON.parse(decrypt(cookies.get('client-hash')!))
      : { accessToken: '', refreshToken: '', personalId: '' };
  } catch (err) {
    console.error(err);
    return { accessToken: '', refreshToken: '', personalId: '' };
  }
};

export const removeClientToken = () => {
  cookies.remove('client-hash');
};

interface IClientTokenData {
  accessToken: string;
  refreshToken: string;
  personalId: string;
}
